module.exports = __webpack_public_path__ + "img/img4.3d5a9db4.png";